export const levels = [
  { title: 'Trainee', cost: '20 b-coin' },
  { title: 'Junior', cost: '30 b-coin' },
  { title: 'Middle', cost: '40 b-coin' },
  { title: 'Senior', cost: '60 b-coin' },
  { title: 'Lead', cost: '70 b-coin' },
  { title: 'Architect', cost: '80 b-coin' },
];

export const certifications = [
  {
    cost: '10 b-coins',
    description:
      '- For completing Foundational-level certifications such as Microsoft Certified: Azure Fundamentals, AWS Cloud Practitioner, or equivalent entry-level exams.',
  },
  {
    cost: '25 b-coins',
    description:
      '- For Associate-level certifications, such as ISTQB Foundation, AWS Solutions Architect Associate, or Scrum Master.',
  },
  {
    cost: '35-40 b-coins',
    description:
      '- For Professional-level certifications or globally recognized advanced programs, including:',
  },
];

export const note =
  'The list of certifications is not complete, so if you pass a certification that is not listed, write to Marvin.';

export const list = [
  'AWS Certified Solutions Architect – Professional',
  'Google Professional Cloud Architect',
  'PMP (Project Management Professional)',
  'Microsoft Certified: Azure Solutions Architect Expert',
];

export const frequentQuestions = [
  {
    id: 'question-0',
    question: 'How do I get b-coins?',
  },
  {
    id: 'question-1',
    question:
      'How many b-coins will I get for a recommendation of a candidate?',
  },
  {
    id: 'question-2',
    question: 'How many company social media tags can I make per month?',
  },
  {
    id: 'question-3',
    question:
      'How often can I complete the task "Conduct Webinars, Courses, or Internal KSS"?',
  },
  {
    id: 'question-4',
    question: 'When is the exchange deadline?',
  },
  {
    id: 'question-5',
    question: 'Can b-coin be presented to someone else?',
  },
  {
    id: 'question-6',
    question: 'How many feedbacks can I leave about the company?',
  },
  {
    id: 'question-7',
    question: 'What certifications can I get b-coin for?',
  },
  // {
  //   id: 'question-8',
  //   question: 'How long should I wait for my order?',
  // },
];
